
import { Vue, Component, Prop,Watch } from "vue-property-decorator";
import DocumentsSidebar from "./DocumentsSidebar.vue";
import PageHeadContainer from "@/components/page/PageHeadContainerNew.vue";
import PageHeadAvatar from "@/components/page/PageHeadAvatarNew.vue";
import PageHeadIcon from "@/components/page/PageHeadIconNew.vue";
import PageInfo from "@/components/page/PageInfo.vue";
import EmailSecondaryIcon from "@/components/icons/EmailSecondaryIcon.vue";
import LocationIcon from "@/components/icons/LocationIcon.vue";
import UiButton from "@/components/button/ui-button.vue";
import Annotation from "@/components/common/Annotation.vue";
import ManagerResendInvitation from "@/components/invite/ManagerResendInvitation.vue";
import Tooltip from "@/components/common/Tooltip.vue";
import Badge from "@/components/common/BadgeNew.vue";
import CustomSwitch from "@/components/common/CustomSwitch.vue";
import RouteNames from "@/entities/RouteNames";
import { Manager } from "@/interface";
import ManagerStatus from "@/entities/manager/ManagerStatus";
import { emailStatusText } from "@/data/userStatuses";
import BadgeColor from "@/entities/BadgeColor";
import { NO_INFORMATION } from "@/data/placeholders";
import UiButtonMessage from "@/components/button/ui-button-message.vue";
import MessageIcon from "@/components/icons/ChatIconNew.vue";
import MessageIconHover from "@/components/icons/ChatIconHoverNew.vue";
import DeleteIcon from "@/components/icons/DeleteIcon.vue";
import DeleteIconHover from "@/components/icons/DeleteIconHover.vue";
import CardPagination from "@/components/card/CardPagination.vue";
import ViewIcon from "@/components/icons/ViewIcon.vue";
import ViewIconBlack from "@/components/icons/ViewIconBlack.vue";
import LIST_PROJECTS from "@/apollo/projects/ListProjects.gql";
import { Project, User } from "@/generated/graphql";
import Added_by from "@/apollo/managers/GetAddedByManager.gql";
import PaginationConfig from "@/entities/PaginationConfig";
import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholder.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import paginationConfig from "@/data/paginationConfig";

interface Conditions {
  offset: number;
  where: {
    manager: {
      user: {
        id: {
          _eq: string;
        };
      };
    };
  };
}

@Component({
  components: {
    "custom-switch": CustomSwitch,
    Badge,
    Tooltip,
    PageHeadContainer,
    PageHeadAvatar,
    PageHeadIcon,
    PageInfo,
    EmailSecondaryIcon,
    ViewIcon,
    ViewIconBlack,
    LocationIcon,
    DocumentsSidebar,
    MessageIcon,
    MessageIconHover,
    DeleteIcon,
    DeleteIconHover,
    UiButton,
    Annotation,
    UiButtonMessage,
    ManagerResendInvitation,
    CardPagination,
    EmptyListPlaceholder,
    LoadingOverlay,
  },
  apollo: {
    projects: {
      query: LIST_PROJECTS,
      variables() {
        return this.conditions;
      },
      update(data) {
        this.paginationConfig.total = data.total.aggregate.count;
        this.paginationConfig.loadedCount = data.project.length;
        return data.project;
      },
    },
  },
})
export default class ManagerHeader extends Vue {
  @Prop({ type: Object, required: true }) readonly manager!: Manager;
  @Prop({ type: String || Number, required: true }) readonly createdById!: String | Number;
  @Prop({ type: Boolean, required: true })
  readonly isEmailUnconfirmed!: boolean;
  @Prop({ type: Boolean, default: false })
  readonly managerStatusProcessing!: boolean;
  @Prop({ type: Boolean, default: false })
  readonly managerDeletionProcessing!: boolean;
  @Prop({ type: Boolean, default: false })
  readonly managerActivationAllowed!: boolean;
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: Boolean, default: false }) readonly getRoleAdmin!: boolean;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: String, required: true }) readonly managerFullName!: string;
  @Prop({ type: String, required: true }) readonly managerUserId!: string;
  @Prop({ type: String, required: true }) readonly managerId!: string;
  @Prop({ type: String, required: true }) readonly companyId!: string;

  BadgeColor: typeof BadgeColor = BadgeColor;
  invitationResent: boolean = false;
  fullname: String = '';
  emailStatusText: string = emailStatusText;
  managerSuspendedText: string = "Account Disabled";
  showActivateTooltip: boolean = false;
  projects?: Project[] = [];
  routeNames = RouteNames;
  isHoveredDelete: boolean = false;
  isHoveredChat: boolean = false;

  paginationConfig: PaginationConfig = { ...paginationConfig };

  get offset(): number {
    const { page, limit } = this.paginationConfig;
    return (page - 1) * limit;
  }
  get fullName() {
    return this.fullname;
  }

  get conditions(): Conditions {
    return {
      offset: this.offset,
      where: {
        manager: {
          user: {
            id: {
              _eq: this.managerUserId,
            },
          },
        },
      },
    };
  }

  get added_conditions() {
    const generateConditions = {
      user_id: this.currentUserId,
    };
    return generateConditions;
  }
mounted() {
  this.fetchAddedBy(this.createdById);
}

async fetchAddedBy(id) {
  try {
     if (id !== null) {
    const { data } = await this.$apollo.query({
      query: Added_by,
      variables: {
        id: id,
      },
    });
    this.fullname =  `${data.user[0].given_name} ${data.user[0].family_name}`; 
     }
     else{
      return 'n/a';
     }
  } catch (error) {
    return ''; 
  }
}

  get completedProjects() {
    if (this.projects) {
      const filterCompletedProjects = this.projects.filter(
        (project) => project.completed && !project.drafted
      );
      return filterCompletedProjects.length;
    }
  }
  get activeProjects() {
    if (this.projects) {
      const filterCompletedProjects = this.projects.filter(
        (project) => !project.completed && !project.drafted
      );
      return filterCompletedProjects.length;
    }
  }
  get empty(): boolean {
    if (!this.projects || this.projects.length === 0) {
      return true;
    }

    return false;
  }

  get emptyListTitle(): string {
    return ``;
  }

updateCrumb() {
        const breadcrubmData = document.querySelector(
            '.site_breadcumb_ul li:nth-child(3) > span'
        );
        if (breadcrubmData) {
            breadcrubmData.innerHTML = `${this.managerName}`;
        }
    }
    @Watch('manager')
    crumbdata() {
        this.updateCrumb();
    }
    @Watch('$route', { immediate: true, deep: true })
    onUrlChange() {
        this.updateCrumb();
    }

  get emptyListSubtitle(): string {
    return `n/a`;
  }

  async handleRefetch(): Promise<void> {
    await this.$apollo.queries.projects.refetch();
    this.$emit("projectNumberChanged", this.paginationConfig.total);
  }

  get resendInvitationTooltipText(): string {
    if (this.invitationResent) {
      return "Invite sent";
    }

    return "Activate manager before resending invitation";
  }

  get isResendInvitationTooltipDisabled(): boolean {
    if (this.isManagerSuspended) {
      return false;
    }

    return !this.invitationResent;
  }

  get isResendInvitationDisabled(): boolean {
    return this.isManagerSuspended || this.invitationResent;
  }
  capitalizedStatus() {
    if (this.status) {
      return (
        this.status.charAt(0).toUpperCase() + this.status.slice(1).toLowerCase()
      );
    }
    return "";
  }
  handleSwitchChange() {
    if (this.isManagerSuspended) {
      this.onActivateManager();
    } else {
      this.$emit("changeStatus");
    }
  }

  get jobTitle(): string {
    return this.manager.user.profile.job_title;
  }
  get isUserDisabled(): boolean {
    return this.isEmailUnconfirmed || this.isManagerSuspended;
  }
  get createdDate(): String {
    const joinedDate = new Date(this.manager.user.created_at);
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const year = joinedDate.getFullYear();
    const month = joinedDate.getMonth();

    const formattedDate = `${monthNames[month]} ${year}`;

    return formattedDate;
  }
  get managerName(): string {
    const firstName = this.manager.user.given_name;
    const lastName = this.manager.user.family_name;
    return `${firstName} ${lastName}`;
  }

  get isAnnotationShown(): boolean {
    return this.isManagerSuspended && !this.managerActivationAllowed;
  }

  get ableToActivate(): boolean {
    return this.isManagerSuspended && this.managerActivationAllowed;
  }

  get location(): string {
    const { country, state, city } = this.manager.user.profile;
    const location = [city, state, country]
      .filter((place) => Boolean(place))
      .join(", ");
    return location || NO_INFORMATION;
  }

  get isManagerSuspended(): boolean {
    return this.manager.status === ManagerStatus.SUSPENDED;
  }
  get status(): string {
    const managerStat = this.manager.status !== null ? this.manager.status : "";
    return managerStat;
  }
  get email(): string {
    return this.manager.user.private_data.email;
  }

  get phone(): string {
    return this.manager.user.private_data.phone;
  }

  onActivateManager(): undefined {
    if (this.ableToActivate) {
      this.$emit("changeStatus");
      return;
    } else {
      this.showActivateTooltip = true;
      this.$router.push({
        name: RouteNames.PRICING,
      });
    }
  }
  onDeleteManager(): undefined {
    if (this.ableToActivate) {
      this.$emit("deleteManager");
      return;
    }

    this.$router.push({
      name: RouteNames.PRICING,
    });
  }

  message(): void {
    if (this.isEmailUnconfirmed) {
      return;
    }

    this.$router.push({
      name: RouteNames.INBOX,
      query: {
        recipientUserId: this.manager.user.id,
      },
    });
  }
}
